import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingPublishedTagId = Brand<number, 'ReportingPublishedTagId'>;
export const ReportingPublishedTagId = createBranded<ReportingPublishedTagId>();
